import Vue from "vue";
import { Feature, LineString, FeatureCollection, Point, Properties } from "@turf/helpers";
import along from "@turf/along";
import length from "@turf/length";
import nearestPointOnLine from "@turf/nearest-point-on-line";
import explode from "@turf/explode";
import { Geometry } from 'geojson';

export function getKmMarkersAlong(line:Feature<any, Properties>, step:number = 1, raceLength?:number, maxMarkers:number = -1):FeatureCollection {
	
	const len:number = length(line);
	if(!raceLength)
		raceLength = len;
	
	//if the track does not have the actual length of the race, let's stretch the km markers to make the length look more real. 
	const lengthPerKm = len / raceLength;
	
	let dist:number = step;

	const numMarkers = maxMarkers > 0 ? maxMarkers : raceLength
	;
	let r:Array<Feature> = [];

	while (dist <= numMarkers) {
		let pt:Feature = along(line, dist*lengthPerKm);

		let zoom = 12.5;
		if(dist % 5 == 0)
			zoom = 3;


		pt.properties = {
			text: dist.toString(),
			progress: dist / raceLength,
			desc: dist + " km",
			cat: "km",
			//anchor: "bottom-right",
			arrow: true,
			z: 0,
			zoom,
		};
		r.push(pt);
		dist += step;
	}

	return {
		type: "FeatureCollection",
		features: r,
	};
}

export function updateMarkerProgress(track:Feature<LineString>, markers:Feature<Geometry>[]):void {
	
	const raceLength = length(track);

	for (let marker of markers) {
		const coll = explode(marker as any)
		const dist = coll.features.reduce((res, item) => {
			let nearest = nearestPointOnLine(track, item);
			return nearest.properties.location < res ? nearest.properties.location : res;
		}, Number.POSITIVE_INFINITY)

		marker.properties!.progress = dist / raceLength;
	}
}